<template>
    <div>
        <h2 class="mb-1">VSE Report</h2>
        
        <div style="display: flex; flex-wrap: wrap; align-items: center;" class="mb-2">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-50"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="prevRange()"
            >
                <feather-icon icon="ChevronLeftIcon" />
            </b-button>

            <b-form-group
                label="Start Date"
                class="mr-50 w-10"
            >
                <date-picker v-model="startDate" type="month" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-if="selectedRangeDate === 'month' || selectedRangeDate === 'quarter'"></date-picker>
                <date-picker v-model="startDate" type="year" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="selectedRangeDate === 'year'"></date-picker>
                <date-picker v-model="startDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="!selectedRangeDate || selectedRangeDate === 'custom'"></date-picker>
            </b-form-group>
        
            <b-form-group
                label="End Date"
                class="mr-50"
            >
                <date-picker v-model="endDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" :disabled="selectedRangeDate === 'month' || selectedRangeDate === 'quarter' || selectedRangeDate === 'year' ? true : false"></date-picker>
            </b-form-group>

            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon ml-0"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="nextRange()"
            >
                <feather-icon icon="ChevronRightIcon" />
            </b-button>
            
            <div :class="!selectedRangeDate ? 'pl-1' : 'pl-1'">
                <b-form-group>
                    <b-form-radio-group
                        v-model="selectedRangeDate"
                        button-variant="outline-primary range-date"
                        buttons
                        class="p-0 mr-2"
                    >
                        <b-form-radio style="height: 37px; padding: 11px;" v-for="(option,index) in optionsRangeDate" :key="index + makeid(6)" :value="option.value">{{option.text}}</b-form-radio>
                        <b-form-radio style="height: 37px; padding: 10px;" v-if="selectedRangeDate" value="x">x</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            
            <b-form-group
                label="Final Status"
            >
                <v-select
                    v-model="finalStatusVSE"
                    placeholder="Final Status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsFinalStatusVSE"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Gender"
            >
                <v-select
                    v-model="genderVSE"
                    placeholder="Gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsGenderVSE"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Referral Source"
            >
                <v-select
                    v-model="referredByVSE"
                    placeholder="Referral Source"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsReferredByVSE"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Connected to PGRC"
            >
                <v-select
                    v-model="connectedToPGRCVSE"
                    placeholder="Connected to PGRC"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsConnectedToPGRCVSE"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Connected to Peer Advocate"
            >
                <v-select
                    v-model="connectedToPeerAdvocate"
                    placeholder="Connected to Peer Advocate"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsYesNo"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Connected to NYS Gaming Commission"
            >
                <v-select
                    v-model="connectedToNYSGamingCommission"
                    placeholder="Connected to NYS Gaming Commission"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsYesNo"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Types of Gambling Engaged In"
            >
                <v-select
                    v-model="gamblingTypesVSE"
                    placeholder="Types of Gambling Engaged In"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsGamblingTypesVSE"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Intervention Status"
            >
                <v-select
                    v-model="interventionStatusVSE"
                    placeholder="Intervention Status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsInterventionStatusVSE"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Pending"
            >
                <v-select
                    v-model="pendingVSE"
                    placeholder="Pending"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsPendingVSE"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="VSE Timeframe"
            >
                <v-select
                    v-model="VSETimeframe"
                    placeholder="VSE Timeframe"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsVSETimeframe"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Appointment Date"
                class="mr-50"
            >
                <date-picker v-model="appointmentDate" type="date" format="MM-DD-YYYY" value-type="MM-DD-YYYY"></date-picker>
            </b-form-group>

            <b-form-group
                label="Follow Up Date"
                class="mr-50"
            >
                <date-picker v-model="followUpDate" type="date" format="MM-DD-YYYY" value-type="MM-DD-YYYY"></date-picker>
            </b-form-group>

            <div>
                <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="mb-1 mt-2 p-75"
                    @click="activeFilterFunction"
                >
                    <feather-icon
                        icon="Xicon"
                        class="mr-50"
                    />
                    <span class="align-middle">Reset filters</span>
                </b-button>
            </div>
        </div>

        <b-card>
            <h5>VSE Forms</h5>
            <hr>
            <b-row>
                <!-- Total Individuals -->
                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ engagementFormCompleted && engagementFormCompleted !== 'NaN' ? engagementFormCompleted.toLocaleString('en-US') : 0 }}
                            </h2>
                            <span>Total VSE Forms</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optionsFinalStatusVSE"
                    :key="index + makeid(6)"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ getCounter(item, 'Final Status') }}
                            </h2>
                            <span>Final Status / {{item}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optionsReferredByVSE"
                    :key="index + makeid(6)"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ getCounter(item, 'Referral Source') }}
                            </h2>
                            <span>Referral Source / {{item}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optionsConnectedToPGRCVSE"
                    :key="index + makeid(6)"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ getCounter(item, 'Connected PGRC') }}
                            </h2>
                            <span>Connected PGRC / {{item}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>
                
                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optionsYesNo"
                    :key="index + makeid(6)"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ getCounter(item, 'Connected to Peer Advocate') }}
                            </h2>
                            <span>Connected to Peer Advocate / {{item}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optionsYesNo"
                    :key="index + makeid(6)"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ getCounter(item, 'Connected to NYS Gaming Commission') }}
                            </h2>
                            <span>Connected to NYS Gaming Commission / {{item}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optionsGamblingTypesVSE"
                    :key="index + makeid(6)"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ getCounter(item, 'Types of Gambling Engaged In') }}
                            </h2>
                            <span>Types of Gambling Engaged In / {{item}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optionsInterventionStatusVSE"
                    :key="index + makeid(6)"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ getCounter(item, 'Intervention Status') }}
                            </h2>
                            <span>Intervention Status / {{item}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optionsVSETimeframe"
                    :key="index + makeid(6)"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ getCounter(item, 'VSE Timeframe') }}
                            </h2>
                            <span>VSE Timeframe / {{item}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optionsPendingVSE"
                    :key="index + makeid(6)"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ getCounter(item, 'Pending') }}
                            </h2>
                            <span>Pending / {{item}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optionsGenderVSE"
                    :key="index + makeid(6)"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ getCounter(item, 'Gender') }}
                            </h2>
                            <span>Gender / {{item}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-card>

        <download-csv 
            :data="json_data"
            class="mb-1 btn btn-default"
            name="reports-vse.csv"
            :style="readyToExport ? 'background: #94221e; color: #fff; cursor: pointer; opacity: 1;' : 'background: #94221e; color: #fff; cursor: no-drop; opacity: 0.5;'"
            delimiter=","
            v-if="isDataSpecialist"
        >
            CSV Export
            <b-spinner small v-if="!readyToExport" />
        </download-csv>
    </div>
</template>

<script>
import { 
    BForm, BButton, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BTable, BFormInvalidFeedback, BFormSelect, BCard, BAvatar, BCardBody,
    BSpinner, BFormRadioGroup, BFormRadio,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { db, auth } from '@/firebase'

export default {
    data() {
        return {
            // validation
            required,
            email,
            totalRows: 0,
            isDataSpecialist: false,
            readyToExport: false,

            // filters
            startDate: null,
            endDate: null,
            region: '',
            borough: '',
            language: '',
            progress: '',
            insurance: '',
            warmTransfer: '',

            finalStatusVSE: '',
            genderVSE: '',
            referredByVSE: '',
            connectedToPGRCVSE: '',
            connectedToPeerAdvocate: '',
            connectedToNYSGamingCommission: '',
            gamblingTypesVSE: '',
            interventionStatusVSE: '',
            pendingVSE: '',
            VSETimeframe: '',
            appointmentDate: null,
            followUpDate: null,

            // data report
            engagementFormCompleted: 0,
            counterInformationKitAccepted: 0,
            counterInitialAppointmentDate: 0,
            counterTotalEligibleCallers: 0,
            counterAttendedFaceToFaceSession: 0,
            counterAdmittedToTreatment: 0,
            countExistingorpastCFEclient: 0,
            countFamilymemberSelf: 0,
            countGAGamAnon: 0,
            countHOPEline: 0,
            countInternetSearch: 0,
            countLegalSystem: 0,
            countOtherserviceprovider: 0,
            countOtherpleasedescribe: 0,
            counterWarmTransfer: 0,
            countFriendsorOtherIndividual: 0,
            countProblemGamblingSelfHelpGroupMeetings: 0,
            countSubstanceUseSelfHelpGroupMeetings: 0,
            countFinancialCounseling: 0,
            countCrisisServices: 0,
            countProblemGamblingTreatmentServices: 0,
            countSubstanceUseTreatmentServices: 0,
            countRecoverySupportServices: 0,

            countHOPElineYes: 0,
            countHOPElineNo: 0,
            countFamilymemberSelfSelfReferral: 0,
            countFamilymemberSelfSpouce: 0,
            countFamilymemberSelfFamilyMember: 0,
            countProblemGamblingSelfHelpGroupMeetingsGA: 0,
            countProblemGamblingSelfHelpGroupMeetingsGamAnon: 0,
            countProblemGamblingSelfHelpGroupMeetingsSmartRecovery: 0,
            countProblemGamblingSelfHelpGroupMeetingsOther: 0,
            countProblemGamblingTreatmentServicesInpatientRehabilitation: 0,
            countProblemGamblingTreatmentServicesResidential: 0,
            countProblemGamblingTreatmentServicesOutpatient: 0,
            countSubstanceUseTreatmentServicesInpatientRehabilitation: 0,
            countSubstanceUseTreatmentServicesResidential: 0,
            countSubstanceUseTreatmentServicesOutpatient: 0,
            countRecoverySupportServicesRCOC: 0,
            countRecoverySupportServicesPeerAdvocate: 0,
            countRecoverySupportServicesOpenAccessCenter: 0,
            countRecoverySupportServicesFamilyNavigator: 0,
            countRecoverySupportServicesRARC: 0,
            countRecoverySupportServicesYouthClubhouse: 0,
            countRecoverySupportServicesGA: 0,
            countRecoverySupportServicesGamAnon: 0,
            countRecoverySupportServicesSmartRecovery: 0,

            // options
            optionsRegion: [],
            optionsBorough: [
                'Bronx',
                'Brooklyn',
                'Manhattan',
                'Queens',
                'Staten Island'
            ],
            // optionsRegion: [
            //     'Bronx',
            //     'Brooklyn',
            //     'Central',
            //     'Finger Lakes',
            //     'Long Island',
            //     'Manhattan',
            //     'Mid-Hudson',
            //     'Northeast',
            //     'Queens',
            //     'Staten Island',
            //     'Western'
            // ],
            optionsLanguage: [],
            optionsClientProgress: [
                'Any Client Status',
                'Engaged',
                'Closed - Attended First Session',
                'Closed - Did not attend first session',
                'Closed - Received information',
                'Closed - Referred to OASAS Program',
                'External Referral',
                'On Hold'
            ],
            optionsInsurance: [],
            optionsWarmTransfer: ['Yes', 'No'],
            optionsYesNo: ['Yes', 'No'],

            // settings table and edit view
            statusEdit: false,
            itemsActivity: [],
            fieldsTable: [
                { key: 'name', sortable: false },
                { key: 'quantity', sortable: false },
            ],
            arrayTableContent: [
                { 'name': 'Existing or past CFE client', quantity: 0 },
                { 'name': 'Family Member / Self', quantity: 0 },
                { 'name': 'GA/ GamAnon', quantity: 0 },
                { 'name': 'HOPEline', quantity: 0 },
                { 'name': 'Warm Transfer', quantity: 0 },
                { 'name': 'Internet Search', quantity: 0 },
                { 'name': 'Legal System', quantity: 0 },
                { 'name': 'Friends or Other Individual', quantity: 0 },
                { 'name': 'Problem Gambling Self-Help Group Meetings', quantity: 0 },
                { 'name': 'Substance Use Self-Help Group Meetings', quantity: 0 },
                { 'name': 'Financial Counseling', quantity: 0 },
                { 'name': 'Crisis Services', quantity: 0 },
                { 'name': 'Problem Gambling Treatment Services', quantity: 0 },
                { 'name': 'Substance Use Treatment Services', quantity: 0 },
                { 'name': 'Recovery Support Services', quantity: 0 },
                { 'name': 'Other (please describe)', quantity: 0 },
                { 'name': 'Other service provider', quantity: 0 },
            ],

            // json to export csv
            json_data: [],

            // get data from db
            optionsClient: [],
            optionsClinician: [],

            // filter
            clientActivityName: null,
            clientActivityStatus: null,
            selectedRangeDate: 'month',
            optionsRangeDate: [
                { text: 'Month', value: 'month' },
                { text: 'Quarter', value: 'quarter' },
                { text: 'Year', value: 'year' },
                { text: 'Custom', value: 'custom' },
            ],
            clinicianProgram: null,
            optionsProgram: [],

            // reports cards
            totalGroupSessions: 0,
            totalIndividualSessions: 0,
            totalRemoteSessions: 0,
            totalNonEnglishClients: 0,
            clientSatisfaction: 0,
            improved: 0,

            // overlay data
            rangeDinamic: false,
            isBusy: true,
            isBusyCalls: true,

            // new filter
            methodOfContact: '',
            contactStatus: '',
            informationKitAccepted: '',
            regionalCFEReceivingTheCall: '',
            readmission: '',
            connectedToPeerAdvocate: '',
            connectedToVSE: '',
            connectedToPeerEducationGroup: '',
            connectedToFamilyEducationGroup: '',
            connectedToAsianServicesProgram: '',
            referralOptions: '',

            // new fields
            optionsMethodOfContact: [
                'Call',
                'Email',
                'Text',
            ],
            optionsContactStatus: [
                'Family Member',
                'Other',
                'Problem Gambler',
            ],
            optionsInformationKitAccepted: [
                'Yes',
                'No',
            ],
            optionsReadmission: [
                'Yes',
                'No',
            ],
            optionsConnectedToPeerAdvocate: [
                'Yes',
                'No',
            ],
            optionsConnected: [
                'Yes',
                'No',
            ],
            optionsConnectedToPeer: [
                'Yes',
                'No',
            ],
            optionsConnectedToFamily: [
                'Yes',
                'No',
            ],
            optionsConnectedToAsian: [
                'Yes',
                'No',
            ],
            optionsReferralOptions: [
                'OASAS Program',
                'Private Practitioner',
                'Recovery Support Services',
            ],

            // opts
            optMethodOfContact: [
                {name: 'Method of Contact/Call', text: 'Call', count: 0},
                {name: 'Method of Contact/Email', text: 'Email', count: 0},
                {name: 'Method of Contact/Text', text: 'Text', count: 0},
            ],
            optContactStatus: [
                {name: 'Caller Type/Family Member', text: 'Family Member', count: 0},
                {name: 'Caller Type/Other', text: 'Other', count: 0},
                {name: 'Caller Type/Problem Gambler', text: 'Problem Gambler', count: 0},
            ],
            optInformationKitAccepted: [
                {name: 'Information Kit Accepted/Yes', text: 'Yes', count: 0},
                {name: 'Information Kit Accepted/No', text: 'No', count: 0},
            ],
            optReadmission: [
                {name: 'Readmission/Yes', text: 'Yes', count: 0},
                {name: 'Readmission/No', text: 'No', count: 0},
            ],
            optConnectedToPeerAdvocate: [
                {name: 'Connected to Peer Advocate/Yes', text: 'Yes', count: 0},
                {name: 'Connected to Peer Advocate/No', text: 'No', count: 0},
            ],
            optConnected: [
                {name: 'Connected to VSE/Yes', text: 'Yes', count: 0},
                {name: 'Connected to VSE/No', text: 'No', count: 0},
            ],
            optConnectedToPeer: [
                {name: 'Connected to peer education group/Yes', text: 'Yes', count: 0},
                {name: 'Connected to peer education group/No', text: 'No', count: 0},
            ],
            optConnectedToFamily: [
                {name: 'Connected to family education group/Yes', text: 'Yes', count: 0},
                {name: 'Connected to family education group/No', text: 'No', count: 0},
            ],
            optConnectedToAsian: [
                {name: 'Connected to Asian Services Program/Yes', text: 'Yes', count: 0},
                {name: 'Connected to Asian Services Program/No', text: 'No', count: 0},
            ],
            optReferralOptions: [
                {name: 'Referral Options/OASAS Program', text: 'OASAS Program', count: 0},
                {name: 'Referral Options/Private Practitioner', text: 'Private Practitioner', count: 0},
                {name: 'Referral Options/Recovery Support Services', text: 'Recovery Support Services', count: 0},
            ],

            optionsFinalStatusVSE: [],
            optionsGenderVSE: [],
            optionsConnectedToPGRCVSE: [],
            optionsInterventionStatusVSE: [],
            optionsPendingVSE: [],
            optionsVSETimeframe: [],
            optionsReferredByVSE: [],
            optionsGamblingTypesVSE: [],
            arrayResults: []
        }
    },
    components: {
        BForm,
        BButton,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BTable,
        BFormInvalidFeedback,
        BFormSelect,
        BCard,
        BAvatar,
        BCardBody,
        BSpinner,
        BFormRadioGroup,
        BFormRadio,
        DatePicker,
        
        // select
        vSelect,

        // date
        flatPickr,

        // Form Validation
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        Ripple,
    },
    computed: {
        ...mapGetters(['arrayFiltradoReportsVSE']),
        ...mapState([])
    },
    watch: {
        selectedRangeDate(val) {
            this.functionDateRange(val)
        },
        clientActivityStatus(val) {
            this.searchClientActivityStatus(val)
        },
        startDate(val) {
            if(val) {
                this.isBusy = true
                this.searchReportsVSEStartDate(val)
                this.functionDateRange(this.selectedRangeDate)
                this.rangeDinamic ? this.rangeDinamic = false : ''
            } else {
                this.searchReportsVSEStartDate(null)
            }
            // this.selectedRangeDate = ''
        },
        endDate(val) {
            if(val) {
                this.isBusy = true
                this.searchReportsVSEEndDate(val)
            } else {
                this.searchReportsVSEEndDate(null)
            }
        },
        finalStatusVSE(val) {
            this.isBusy = true
            this.searchReportsVSEFinalStatus(val)
        },
        genderVSE(val) {
            this.isBusy = true
            this.searchReportsVSEGender(val)
        },
        referredByVSE(val) {
            this.isBusy = true
            this.searchReportsVSEReferredBy(val)
        },
        connectedToPGRCVSE(val) {
            this.isBusy = true
            this.searchReportsVSEConnectedToPGRC(val)
        },
        connectedToPeerAdvocate(val) {
            this.isBusy = true
            this.searchReportsVSEConnectedToPeer(val)
        },
        connectedToNYSGamingCommission(val) {
            this.isBusy = true
            this.searchReportsVSEConnectedToNYS(val)
        },
        gamblingTypesVSE(val) {
            this.isBusy = true
            this.searchReportsVSEGamblingTypes(val)
        },
        interventionStatusVSE(val) {
            this.isBusy = true
            this.searchReportsVSEIntervention(val)
        },
        pendingVSE(val) {
            this.isBusy = true
            this.searchReportsVSEPending(val)
        },
        VSETimeframe(val) {
            this.isBusy = true
            this.searchReportsVSETimeframe(val)
        },
        appointmentDate(val) {
            this.isBusy = true
            this.searchReportsVSEAppointmentDate(val)
        },
        followUpDate(val) {
            this.isBusy = true
            this.searchReportsVSEFollowUpDate(val)
        },
        arrayFiltradoReportsVSE(val) {
            this.isBusy = true
            var arrayExport = []

            this.arrayResults.forEach(ele => {
                ele.count = 0
            })

            this.engagementFormCompleted = val.length
            // console.log(val.length)
            
            val.forEach(dataClientActivity => {
                // console.log(dataClientActivity.contactDateVSE, dataClientActivity.appointmentDateVSE, dataClientActivity.followUpDateVSE)
                if(dataClientActivity.finalStatusVSE) {
                    var filter = this.arrayResults.filter(ele => ele.text === dataClientActivity.finalStatusVSE || dataClientActivity.finalStatusVSE.includes(ele.text))
                    // console.log(filter.length)
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.genderVSE) {
                    var filter = this.arrayResults.filter(ele => ele.text === dataClientActivity.genderVSE || dataClientActivity.genderVSE.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.connectedToPGRCVSE) {
                    var filter = this.arrayResults.filter(ele => ele.text === dataClientActivity.connectedToPGRCVSE || dataClientActivity.connectedToPGRCVSE.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.interventionStatusVSE) {
                    var filter = this.arrayResults.filter(ele => ele.text === dataClientActivity.interventionStatusVSE || dataClientActivity.interventionStatusVSE.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.pendingVSE) {
                    var filter = this.arrayResults.filter(ele => ele.text === dataClientActivity.pendingVSE || dataClientActivity.pendingVSE.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.VSETimeframe) {
                    var filter = this.arrayResults.filter(ele => ele.text === dataClientActivity.VSETimeframe || dataClientActivity.VSETimeframe.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.referredByVSE) {
                    var filter = this.arrayResults.filter(ele => ele.text === dataClientActivity.referredByVSE || dataClientActivity.referredByVSE.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.typesofGamblingEngagedInVSE) {
                    var filter = this.arrayResults.filter(ele => ele.text === dataClientActivity.typesofGamblingEngagedInVSE || dataClientActivity.typesofGamblingEngagedInVSE.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.connectedToPeerAdvocateVSE) {
                    var filter = this.arrayResults.filter(ele => ele.text === dataClientActivity.connectedToPeerAdvocateVSE || dataClientActivity.connectedToPeerAdvocateVSE.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.connectedtoNYSGamingCommissionVSE) {
                    var filter = this.arrayResults.filter(ele => ele.text === dataClientActivity.connectedtoNYSGamingCommissionVSE || dataClientActivity.connectedtoNYSGamingCommissionVSE.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                arrayExport.push({
                    notes: dataClientActivity.notesVSE ? dataClientActivity.notesVSE : '',
                    finalStatus: dataClientActivity.finalStatusVSE ? dataClientActivity.finalStatusVSE : '',
                    staffMemberCompletingForm: dataClientActivity.staffMemberCompletingFormVSE ? dataClientActivity.staffMemberCompletingFormVSE : '',
                    contactDate: dataClientActivity.contactDateVSE ? dataClientActivity.contactDateVSE : '',
                    gender: dataClientActivity.genderVSE ? dataClientActivity.genderVSE : '',
                    referredBy: dataClientActivity.referredByVSE ? dataClientActivity.referredByVSE : '',
                    familyMemberSelf: dataClientActivity.familyMemberSelfVSE ? dataClientActivity.familyMemberSelfVSE : '',
                    problemGamblingTreatmentServices: dataClientActivity.problemGamblingTreatmentServicesVSE ? dataClientActivity.problemGamblingTreatmentServicesVSE : '',
                    problemGamblingSelfHelpGroupMeetings: dataClientActivity.problemGamblingSelfHelpGroupMeetingsVSE ? dataClientActivity.problemGamblingSelfHelpGroupMeetingsVSE : '',
                    substanceUseTreatmentServices: dataClientActivity.substanceUseTreatmentServicesVSE ? dataClientActivity.substanceUseTreatmentServicesVSE : '',
                    recoverySupportServices: dataClientActivity.recoverySupportServicesVSE ? dataClientActivity.recoverySupportServicesVSE : '',
                    otherReferredBy: dataClientActivity.otherReferredByVSE ? dataClientActivity.otherReferredByVSE : '',
                    warmTransfer: dataClientActivity.warmTransferVSE ? dataClientActivity.warmTransferVSE : '',
                    pgrcPmSE: dataClientActivity.pgrcPmSE ? dataClientActivity.pgrcPmSE : '',
                    PGRCPrivatePractitioner: dataClientActivity.PGRCPrivatePractitionerVSE ? dataClientActivity.PGRCPrivatePractitionerVSE : '',
                    OASASProgram: dataClientActivity.OASASProgramVSE ? dataClientActivity.OASASProgramVSE : '',
                    GamingFacility: dataClientActivity.GamingFacilityVSE ? dataClientActivity.GamingFacilityVSE : '',
                    connectedToPGRC: dataClientActivity.connectedToPGRCVSE ? dataClientActivity.connectedToPGRCVSE : '',
                    connectedToPeerAdvocate: dataClientActivity.connectedToPeerAdvocateVSE ? dataClientActivity.connectedToPeerAdvocateVSE : '',
                    connectedtoNYSGamingCommission: dataClientActivity.connectedtoNYSGamingCommissionVSE ? dataClientActivity.connectedtoNYSGamingCommissionVSE : '',
                    typesofGamblingEngagedIn: dataClientActivity.typesofGamblingEngagedInVSE ? dataClientActivity.typesofGamblingEngagedInVSE : '',
                    interventionStatus: dataClientActivity.interventionStatusVSE ? dataClientActivity.interventionStatusVSE : '',
                    pending: dataClientActivity.pendingVSE ? dataClientActivity.pendingVSE : '',
                    appointmentDate: dataClientActivity.appointmentDateVSE ? dataClientActivity.appointmentDateVSE : '',
                    followUpDate: dataClientActivity.followUpDateVSE ? dataClientActivity.followUpDateVSE : '',
                    Timeframe: dataClientActivity.VSETimeframe ? dataClientActivity.VSETimeframe : '',
                })
            })

            this.isBusy = false
            this.isBusyCalls = false

            this.json_data = arrayExport
            this.readyToExport = true
        }
    },
    methods: {
        ...mapActions(['setSnapshotClientActivityReportsVSE', 'searchReportsVSEStartDate', 'searchReportsVSEEndDate', 'searchReportsVSEFinalStatus', 'searchReportsVSEGender', 'searchReportsVSEReferredBy', 'searchReportsVSEConnectedToPGRC', 'searchReportsVSEConnectedToPeer', 'searchReportsVSEConnectedToNYS', 'searchReportsVSEGamblingTypes', 'searchReportsVSEIntervention', 'searchReportsVSEPending', 'searchReportsVSETimeframe', 'searchReportsVSEAppointmentDate', 'searchReportsVSEFollowUpDate']),
        makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        getCounter(payload, type) {
            var filterResult = this.arrayResults.filter(ele => ele.text === payload && ele.type === type)
            if(filterResult.length) {
                return filterResult[0].count
            } else {
                return 0
            }
        },
        activeFilterFunction() {
            this.startDate = null
            this.endDate = null
            this.finalStatusVSE = ''
            this.genderVSE = ''
            this.referredByVSE = ''
            this.connectedToPGRCVSE = ''
            this.connectedToPeerAdvocate = ''
            this.connectedToNYSGamingCommission = ''
            this.gamblingTypesVSE = ''
            this.interventionStatusVSE = ''
            this.pendingVSE = ''
            this.VSETimeframe = ''
            this.appointmentDate = null
            this.followUpDate = null
            
            // this.functionFilters()
            this.activeFilters = false
        },
        functionDateRange(val) {
            if(val === 'month') {
                // console.log(this.startDate)
                if(this.startDate) {
                    // '24/03/2022'
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(this.startDate,this.endDate)
                }
            } else if(val === 'quarter') {
                if(this.startDate) {
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                }
            } else if(val === 'year') {
                if(this.startDate) {
                    var formatDateNew = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var getYear = moment(formatDateNew).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = '01/01/'+getYear
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                } else {
                    var getYear = moment(Date.now()).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = moment('01/01/'+getYear).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,dateUpdateFormat)
                }
            } else if(val === 'x') {
                this.selectedRangeDate = ''
                this.startDate = null
                this.endDate = null
            }
        },
        prevRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).subtract(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        nextRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).add(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
    },
    created() {
        var user = auth.currentUser
        db.collection('usuarios').doc(user.uid).get()
        .then(doc => {
            this.isDataSpecialist = false
            if(doc.data().role === 'staff') {
                if(doc.data().permissions.includes('data specialist')) {
                    this.isDataSpecialist = true
                }
            } else if(doc.data().role === 'admin') {
                this.isDataSpecialist = true
            }
        })

        setTimeout(() => {
            this.$http.get('https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/prod/vse-reports')
            .then(res => {
                // console.log(res.data.length)
                // this.engagementFormCompleted = res.data.length

                this.setSnapshotClientActivityReportsVSE(res.data)
                // this.isBusy = false
                // this.isBusyCalls = false
            })
        }, 2500)

        // filters
        this.startDate = null
        this.endDate = null
        this.finalStatusVSE = ''
        this.genderVSE = ''
        this.referredByVSE = ''
        this.connectedToPGRCVSE = ''
        this.connectedToPeerAdvocate = ''
        this.connectedToNYSGamingCommission = ''
        this.gamblingTypesVSE = ''
        this.interventionStatusVSE = ''
        this.pendingVSE = ''
        this.VSETimeframe = ''
        this.appointmentDate = null
        this.followUpDate = null

        this.searchReportsVSEStartDate(null)
        this.searchReportsVSEEndDate(null)
        this.searchReportsVSEFinalStatus(null)
        this.searchReportsVSEGender(null)
        this.searchReportsVSEReferredBy(null)
        this.searchReportsVSEConnectedToPGRC(null)
        this.searchReportsVSEConnectedToPeer(null)
        this.searchReportsVSEConnectedToNYS(null)
        this.searchReportsVSEGamblingTypes(null)
        this.searchReportsVSEIntervention(null)
        this.searchReportsVSEPending(null)
        this.searchReportsVSETimeframe(null)
        this.searchReportsVSEAppointmentDate(null)
        this.searchReportsVSEFollowUpDate(null)

        this.arrayResults = []

        db.collection('taxonomies').doc('vse').get()
        .then(docTaxonomia => {
            this.optionsFinalStatusVSE = docTaxonomia.data().FinalStatusVSE
            this.optionsFinalStatusVSE.unshift('Open')
            this.optionsFinalStatusVSE.forEach(eleTax => {
                this.arrayResults.push({text: eleTax, type: 'Final Status', count: 0})
            })

            // this.optionsStaffMemberCompletingFormVSE = docTaxonomia.data().StaffMemberCompletingFormVSE
            this.optionsGenderVSE = docTaxonomia.data().GenderVSE
            this.optionsGenderVSE.forEach(eleTax => {
                this.arrayResults.push({text: eleTax, type: 'Gender', count: 0})
            })

            this.optionsConnectedToPGRCVSE = docTaxonomia.data().ConnectedToPGRCVSE
            this.optionsConnectedToPGRCVSE.forEach(eleTax => {
                this.arrayResults.push({text: eleTax, type: 'Connected PGRC', count: 0})
            })

            this.optionsInterventionStatusVSE = docTaxonomia.data().InterventionStatusVSE
            this.optionsInterventionStatusVSE.forEach(eleTax => {
                this.arrayResults.push({text: eleTax, type: 'Intervention Status', count: 0})
            })

            this.optionsPendingVSE = docTaxonomia.data().PendingVSE
            this.optionsPendingVSE.forEach(eleTax => {
                this.arrayResults.push({text: eleTax, type: 'Pending', count: 0})
            })

            this.optionsVSETimeframe = docTaxonomia.data().VSETimeframe
            this.optionsVSETimeframe.forEach(eleTax => {
                this.arrayResults.push({text: eleTax, type: 'VSE Timeframe', count: 0})
            })

            this.optionsReferredByVSE = docTaxonomia.data().referralSourceVSE
            this.optionsReferredByVSE.forEach(eleTax => {
                this.arrayResults.push({text: eleTax, type: 'Referral Source', count: 0})
            })

            this.optionsGamblingTypesVSE = docTaxonomia.data().typesOfGamblingEngagedInVSE
            this.optionsGamblingTypesVSE.forEach(eleTax => {
                this.arrayResults.push({text: eleTax, type: 'Types of Gambling Engaged In', count: 0})
            })

            this.optionsYesNo.forEach(eleTax => {
                this.arrayResults.push({text: eleTax, type: 'Connected to Peer Advocate', count: 0})
            })

            this.optionsYesNo.forEach(eleTax => {
                this.arrayResults.push({text: eleTax, type: 'Connected to NYS Gaming Commission', count: 0})
            })
        })
    }
}
</script>

<style>
.mx-input {
    height: 37px !important;
}
.hidden_header {
    display: none;
}
.form-control {
    background: #fff !important;
    background-color: #fff !important;
}
.range-date {
    padding: 8px;
    margin-top: 27px;
}
.vs__dropdown-option {
  white-space: normal !important;
}
.vs__dropdown-toggle {
  max-height: 38px;
}
.vs__selected-options {
  overflow: auto;
}
.vs__selected-options {
    overflow-x: hidden;
    overflow-y: hidden;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>